import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  EnumService,
  InstituicaoEnsinoService,
  RepresentacaoInstituicaoEnsinoService,
  TipoRepresentacaoInstituicaoEnsinoService,
} from '../../../../api/services';
import { ApiService } from '@core/providers/http';
import { AuthService } from '@core/service/auth.service';
import { dateRangeValidator } from '@core/validators/date-range.validator';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { InputMaskModule } from 'primeng/inputmask';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-edit-representante',
  imports: [
    CommonModule,
    ButtonModule,
    ReactiveFormsModule,
    DialogModule,
    DatePickerModule,
    FileUploadModule,
    InputTextModule,
    Select,
    InputMaskModule,
    Toast,
  ],
  providers: [
    MessageService,
    ApiService,
    AuthService,
    DialogService,
    InstituicaoEnsinoService,
    TipoRepresentacaoInstituicaoEnsinoService,
    RepresentacaoInstituicaoEnsinoService,
    EnumService,
  ],
  templateUrl: './edit-representante.component.html',
  styleUrl: './edit-representante.component.scss',
  standalone: true,
})
export class EditRepresentanteComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  fb = inject(FormBuilder);
  config = inject(DynamicDialogConfig);
  messageService = inject(MessageService);
  dialogService = inject(DialogService);
  enumService = inject(EnumService);
  perfilRepresentante: any; // Recebe os dados do representante via Input

  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  private representanteInstituicaoEnsinoService = inject(
    RepresentacaoInstituicaoEnsinoService,
  );
  tiposRepresentacao: any[] = [];
  nacionalidades: any[] = [
    {
      id: 1,
      designacao: 'Nacional',
    },
    {
      id: 2,
      designacao: 'Estrangeira',
    },
  ];
  representantes: any[] = [];
  isPatching = false;
  representacaoForm!: FormGroup;
  file: any;
  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL
  selectedFile: File | null = null;
  fotoPreviewMap: { [id: number]: string | ArrayBuffer | null } = {};

  editIndex: number | null = null;
  private tipoRepresentacaoService = inject(
    TipoRepresentacaoInstituicaoEnsinoService,
  );
  isInternalInstitution: boolean = false;
  profileEducationalInstitution: any;
  isLoading: boolean = false;

  constructor() {
    this.representacaoForm = this.fb.group({
      nome: ['', Validators.required],
      telefone: ['', [Validators.required]],
      bi: ['', Validators.required],
      emailRepresentante: ['', [Validators.required, Validators.email]],
      TipoRepresentacaoInstituicaoEnsinoID: ['', Validators.required],
      NacionalidadeEnum: [{ value: '', disabled: true }, [Validators.required]],
      ativo: [true],
      id: [null, Validators.required],
      usernameRepresentante: [''],
      InstituicaoEnsinoID: [this.instituicaoEnsinoID, Validators.required],
      Foto: [''], // novo campo
    });

    this.representacaoForm.controls?.[
      'NacionalidadeEnum'
    ].valueChanges.subscribe((value: any) => {
      if (!this.isPatching) {
        this.representacaoForm.patchValue({ bi: '' });
        this.onNacionalidadeChange(value);
      }
    });

    this.representacaoForm.controls['bi'].valueChanges.subscribe(() => {
      if (!this.isPatching) {
        this.representacaoForm.patchValue({
          nome: '',
          telefone: '',
          // emailRepresentante: '',
        });
      }
    });
  }

  ngOnInit(): void {
    this.loadTiposRepresentacao();
    this.loadInstitutionDetails();
    this.loadNacionalidade();

    if (this.config && this.config.data && this.config.data.representante) {
      this.perfilRepresentante = this.config.data.representante;

      this.patchRepresentante(this.perfilRepresentante);
    } else {
      console.error('perfilRepresentante não foi passado para o componente!');
    }
  }

  get f() {
    return this.representacaoForm.controls;
  }

  get instituicaoEnsinoID(): number {
    return Number(this.route.snapshot.paramMap.get('id'));
  }

  loadNacionalidade() {
    this.enumService.getAllNacionalidadeEnum().subscribe((response) => {
      if (response?.data) {
        this.nacionalidades = Object.entries(response.data).map(
          ([key, value]) => ({
            id: Number(key),
            designacao: value,
          }),
        );
      }
    });
  }

  loadInstitutionDetails(): void {
    this.instituicaoEnsinoService
      .show(this.instituicaoEnsinoID as any)
      .subscribe((data: any) => {
        this.profileEducationalInstitution = data;
      });
  }

  patchRepresentante(perfilEmpresagestora: any): void {
    this.isPatching = true;
    this.representacaoForm.patchValue({
      ...perfilEmpresagestora,
      id: +perfilEmpresagestora.id,
      NacionalidadeEnum: +perfilEmpresagestora.nacionalidadeEnum,
      bi: perfilEmpresagestora.bi,
      nome: perfilEmpresagestora.nome,
      telefone: perfilEmpresagestora.telefone,
      emailRepresentante: perfilEmpresagestora.emailRepresentante,
      TipoRepresentacaoInstituicaoEnsinoID:
        +perfilEmpresagestora.tipoRepresentacaoInstituicaoEnsinoID,
      ativo: true,
      instituicaoEnsinoID: +perfilEmpresagestora.instituicaoEnsinoID,
      Foto: perfilEmpresagestora.Foto,
    });

    this.representacaoForm.patchValue({
      bi: perfilEmpresagestora.bi,
    });
    this.representanteInstituicaoEnsinoService
      .getFotoRepresentacaoInstituicaoEnsinoById(perfilEmpresagestora.id)
      .subscribe((response) => {
        if (!response) return;

        const file = new File([response], 'representative-photo.jpg', {
          type: response.type,
        });
        this.selectedFile = file;

        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result as string;
        };
        reader.readAsDataURL(file);

        this.representacaoForm.patchValue({ Foto: file });
      });

    this.representacaoForm.patchValue({
      nome: perfilEmpresagestora.nome,
      telefone: perfilEmpresagestora.telefone,
    });

    ['telefone', 'emailRepresentante', 'NacionalidadeEnum'].forEach(
      (controlName) => {
        this.representacaoForm.get(controlName)?.enable();
      },
    );

    ['NacionalidadeEnum', 'Bi', 'nome'].forEach((controlName) =>
      this.representacaoForm.get(controlName)?.disable(),
    );

    this.isPatching = false;
  }

  onNacionalidadeChange(value: any) {
    this.isInternalInstitution = value === 1; // 'INTERNA' is selected
    if (this.isInternalInstitution) {
      ['nome'].forEach((control) => {
        this.representacaoForm.get(control)?.disable();
      });
    } else {
      ['nome', 'telefone', 'emailRepresentante'].forEach((control) => {
        this.representacaoForm.get(control)?.enable();
      });
    }
  }

  searchDocumentNumber() {
    const biVal = this.f['bi']?.value || this.f['Bi']?.value;
    if (!biVal) return;

    this.authService.consultarBi(biVal as string).subscribe((result) => {
      const isSuccess =
        result?.retorno?.codigo == 200 ||
        result?.data?.code == 200 ||
        result?.data?.codigo == 200;
      if (isSuccess) {
        const personData = result.data?.data || result.data || {};
        const firstName = personData.first_name || personData.nome || '';
        const lastName = personData.last_name || personData.sobrenome || '';
        const nomeCompleto = `${firstName} ${lastName}`.trim();

        const patchValues: any = {};
        if (nomeCompleto) {
          patchValues.nome = nomeCompleto;
        }
        if (personData.numeroContacto || personData.telefone) {
          patchValues.telefone =
            personData.numeroContacto || personData.telefone;
        }
        if (personData.email) {
          patchValues.emailRepresentante = personData.email;
        }

        this.representacaoForm.patchValue(patchValues);

        this.representacaoForm.controls['emailRepresentante'].enable();
        this.representacaoForm.controls['telefone'].enable();
      }
    });
  }

  loadTiposRepresentacao() {
    this.tipoRepresentacaoService.list().subscribe((tiposRepresentacao) => {
      this.tiposRepresentacao = tiposRepresentacao;
    });
  }

  choose(event: any, callback: () => void) {
    callback();
  }

  onSelectedFiles(event: { currentFiles: any }) {
    this.file = event.currentFiles[0];

    //Adicionar validação de tamanho da imagem (ex: máx. 2MB)
    const maxSizeMB = 2;
    if (this.file.size > maxSizeMB * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Imagem muito grande',
        detail: `A imagem deve ter no máximo ${maxSizeMB}MB.`,
        life: 3000,
      });
      return;
    }

    const isImage = this.file.type.startsWith('image/');
    if (!isImage) {
      this.messageService.add({
        severity: 'error',
        summary: 'Formato inválido',
        detail: 'Apenas imagens são permitidas.',
        life: 3000,
      });
      return;
    }

    if (this.file) {
      this.selectedFile = this.file;
      this.representacaoForm.patchValue({ Foto: this.file });

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.file);
    }
  }

  onSubmit() {
    if (this.representacaoForm.valid) {
      if (this.representacaoForm.value) {
        const rawData = this.representacaoForm.getRawValue();
        const formData = new FormData();
        for (const key in rawData) {
          if (key !== 'Foto') {
            if (!rawData[key]) continue;
            formData.append(key, rawData[key]);
          }
        }

        formData.append(
          'usernameRepresentante',
          !this.isInternalInstitution ? rawData.emailRepresentante : rawData.bi,
        );

        if (rawData.Foto && this.selectedFile) {
          formData.append('foto', this.selectedFile);
        }

        this.ref.close(formData); // envia o FormData para o componente pai
      } else {
        this.representacaoForm.markAllAsTouched();
        if (!this.selectedFile) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: 'Por favor selecione uma imagem para o logotipo.',
          });
        }
      }
    }
    if (this.representacaoForm.invalid) {
      this.representacaoForm.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Por favor, preencha todos os campos obrigatórios.',
      });
      return;
    }
  }

  cancel() {
    if (this.ref) {
      this.ref.close(); // Fecha a modal
    } else {
      console.error('DynamicDialogRef não foi injetado corretamente!');
    }
  }
}
